import { render } from "./index.vue?vue&type=template&id=8d9a7dee&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=8d9a7dee&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9a7dee"]])

export default __exports__